import { useSnapshot } from 'valtio';
import { serviceState } from '../workspace/lib/state';
import { UserStatus, useUserStatus } from './useUserStatus';

/**
 * Hook that gets the current user's status information from ServiceModule state.
 */
export function useCurrentUserStatus(): UserStatus {
  const state = useSnapshot(serviceState);
  return useUserStatus({ userId: state?.id });
}
